import { colors } from "../../styles/theme"
import { TournamentTabs } from "./TournamentTabs"
import { BracketsContent } from "./BracketsContent"
import { LeaderboardContent } from "./LeaderboardContent"
import { Event, EventCategory } from "./types"

interface TournamentContentProps {
  activeTab: "brackets" | "leaderboard"
  selectedEvent: string
  selectedCategory: string
  drivers: any[]
  getSelectedEvent: () => Event | undefined
  getSelectedCategory: () => EventCategory | undefined
  getBracketStatusColor: (status: string) => string
  getBracketStatusLabel: (status: string) => string
  onTabChange: (tab: "brackets" | "leaderboard") => void
  onBracketCreated: (bracketId: string) => void
}

export function TournamentContent({
  activeTab,
  selectedEvent,
  selectedCategory,
  drivers,
  getSelectedEvent,
  getSelectedCategory,
  getBracketStatusColor,
  getBracketStatusLabel,
  onTabChange,
  onBracketCreated
}: TournamentContentProps) {
  return (
    <div
      className="border rounded-xl"
      style={{ backgroundColor: colors.background.secondary, borderColor: colors.border.primary }}
    >
      {/* Tabs */}
      <TournamentTabs activeTab={activeTab} onTabChange={onTabChange} />

      {/* Content */}
      <div className="p-6">
        {activeTab === "brackets" && (
          <BracketsContent
            selectedEvent={selectedEvent}
            selectedCategory={selectedCategory}
            getSelectedEvent={getSelectedEvent}
            getSelectedCategory={getSelectedCategory}
            getBracketStatusColor={getBracketStatusColor}
            getBracketStatusLabel={getBracketStatusLabel}
            onBracketCreated={onBracketCreated}
          />
        )}

        {activeTab === "leaderboard" && (
          <LeaderboardContent drivers={drivers} />
        )}
      </div>
    </div>
  )
} 